import PortalIdParser from 'PortalIdParser';
import { DEFAULT_MUX_POSTER_WIDTH, MUX_THUMBNAIL_DOMAIN } from '../constants';

export function buildMuxThumbnailUrl(
  playbackId: string,
  width = DEFAULT_MUX_POSTER_WIDTH
) {
  return `https://${MUX_THUMBNAIL_DOMAIN}/${playbackId}/thumbnail.jpg?width=${width}`;
}

export function appendCacheBuster(url: string, timestamp: number) {
  if (url.includes('?')) {
    return `${url}&t=${timestamp}&errorOnPlaceholder=true`;
  } else {
    return `${url}?t=${timestamp}&errorOnPlaceholder=true`;
  }
}

export function getFilesDashUrl(fileId: number, source = 'video-detail-ui') {
  return `/files/${PortalIdParser.get()}?showDetails=${fileId}&source=${source}`;
}

/**
 * Builds a new-style react module based video share page URL (/share/video/:identifier).
 *
 * @param domain - customer CMS domain
 * @param videoIdentifier - Either a share key (opaque string obtained via
 *   getOrCreateShareKey RPC, used for "anyone with the link" sharing) or a
 *   numeric videoId (used when sharing with portal members who can access the
 *   video directly).
 */
export function buildSharePageUrl(
  domain: string,
  videoIdentifier: string | number
) {
  return `https://${domain}/share/video/${videoIdentifier}`;
}

/** Builds a legacy-style video share page URL (/share/hubspotvideo/:videoId), powered by `video-share-ui` */
export function buildLegacySharePageUrl(domain: string, videoId: number) {
  return `https://${domain}/share/hubspotvideo/${videoId}`;
}
